import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID,

    IProjectItemsLoadByProjectIdAction,
    IProjectItemLoadFailureAction,
    IProjectItemLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    IProjectItemCreateSuccessAction,
    IProjectItemCreateFailureAction,
    IProjectItemCreateAction,
    IProjectItemSaveSuccessAction,
    IProjectItemSaveFailureAction,
    ACTION_PROJECTITEM_SAVE,
    IProjectItemSaveAction,
    SaveFailure,
    SaveSuccess,
    ACTION_PROJECTITEM_CREATE,
    CreateSuccess,
    CreateFailure,

} from "../actions/projectItems";
import { projectItemApi } from "../services/projectItem";


export const
    getProjectItemsByProjectIdEpic = (action$): Observable<IProjectItemLoadSuccessAction | IProjectItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID)
            .mergeMap((action: IProjectItemsLoadByProjectIdAction) => {
                return projectItemApi
                    .getProjectItemsByProjectId(action.projectId)
                    .map(response =>
                        LoadSuccess(response.projectItems, response.projectItemCategories, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectItemEpic = (action$): Observable<IProjectItemSaveSuccessAction | IProjectItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEM_SAVE)
            .mergeMap((action: IProjectItemSaveAction) => {
                return projectItemApi
                    .setProjectItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.projectItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createProjectItemEpic = (action$): Observable<IProjectItemCreateSuccessAction | IProjectItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEM_CREATE)
            .mergeMap((action: IProjectItemCreateAction) => {
                return projectItemApi
                    .createProjectItem(action.projectId)
                    .map(response =>
                        CreateSuccess(response.projectItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }


